import React, { useEffect, useState } from 'react'
import AddIssueDynemicForm from '../../Services/addIssueDynemicFrom';
import Drawer from "react-modern-drawer";
import CustomLogisticsTable from "../../Logistics/CustomLogisticsTable";

import backicon from "../../../../Assets/icons/backIcon.svg";
import editIcon from "../../../../Assets/icons/Un-Checkbox.svg";
import deleteIcon from "../../../../Assets/icons/trash.svg";

import "react-modern-drawer/dist/index.css";
import axiosInstance from '../../../../http.common';
import AddVehicleDetails from './AddVehicleDetails';

const VehicleDetails = ({visit_id}) => {

    const [formData, setFormData] = useState({});
    const [validationErrors,setValidationErrors] = useState({})
    const [isOpen, setIsOpen] = React.useState(false);
    const [customerId, setCustomerId] = useState([]);
    const [showParentDesignation, setShowParentDesignation] = useState(false);
    const [make, setMake] = useState([]);
    const [model, setModel] = useState([]);
    const [product, setProduct] = useState([]);
    const [subproduct, setSubproduct] = useState([]);
    const [variantDD, setVariantDD] = useState([]);
    const [color, setColor] = useState([]);
    const [fuelType, setFuelType] = useState([]);

    const [isEdit, setIsEdit] = useState(false);

    const [ vehicleDetails , setVehicleDetailsData ] = useState([])

    const [  vehicleId , setVehicleId ] = useState(0)


    const token = localStorage.getItem("authToken");

    const [physicalStockData, setphysicalStockData] = useState([]);

    const [currentPage, setCurrentPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [totalRecords, setTotalRecords] = useState(0);

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
        // fetchDepartments(newPage);
      };

    const toggleDrawer = () => {
        setIsOpen((prevState) => !prevState);
        if(isEdit){
          setIsEdit(!isEdit)
        }
        // setFormData({})
        
      };

      const handleEdit = (rowData) => {
        console.log(rowData, "ROWDATA")
        setIsEdit(true);
        setVehicleId(rowData?.vehicle_id)
        toggleDrawer()
      }

      useEffect(() => {
        console.log(formData, "FORMDATAVEHICLE")
      },[formData])

      const handleDrawerFormVehicle = async (formData) => {
        console.log("clicked");
        const errors = {};
        let isValid = true;
      
        VehicleDrawerInputs.forEach((field) => {
          if (field.validation && field.validation.required) {
            if (!formData[field.name]) {
              errors[field.name] = "This field is required";
              isValid = false;
            }
          } else if (
            field.required &&
            field.validation &&
            field.validation.pattern &&
            !field.validation.pattern.test(formData[field.name])
          ) {
            errors[field.name] = field.validation.message;
            isValid = false;
          }
        });
      
        if (!isValid) {
          setValidationErrors(errors);
          return;
        }
      
        // Handle file upload if is_test_drive is true

        const formDataObj = new FormData();
        formDataObj.append("business_partner_id", 1);
        formDataObj.append("visit_id", visit_id);
        formDataObj.append("product_id", formData.product_id);
        formDataObj.append("subproduct_id", formData.subproduct_id);
        formDataObj.append("make_id", formData.make_id);
        formDataObj.append("model_id", formData.model_id);
        formDataObj.append("variant_id", formData.variant_id);
        formDataObj.append("color_id", formData.color_id);
        formDataObj.append("fuel_type_id", formData.fuel_type_id);
        formDataObj.append("remark", formData.remark);
        formDataObj.append("is_test_drive", formData.is_test_drive ? 1 : 0);
      
        // Add test drive details and files if test drive is required
        if (formData.is_test_drive) {
          formDataObj.append("test_drive_assistance_name", formData.test_drive_assistance_name || "");
          // formDataObj.append("test_drive_Date", formData.test_drive_Date || "");
          formDataObj.append("test_drive_Date", formData.test_drive_Date ? new Date(formData.test_drive_Date).toISOString() : "");
          formDataObj.append("single_image", formData.single_image); 
          formDataObj.append("family_image", formData.family_image); 
        }
      
        try {
          let response;
      
          if (formData.is_test_drive) {
            // API call for test drive with file upload
            response = await axiosInstance.post("/salesvisit/createvisitvehiclewithfile", formDataObj, {
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${token}`,
              },
            });
          } else {
            // API call for normal case without file upload
            response = await axiosInstance.post(
              "/salesvisit/createcustomervisitvehicle",
              {
                business_partner_id: 1,
                visit_id: visit_id,
                product_id: formData.product_id,
                subproduct_id: formData.subproduct_id,
                make_id: formData.make_id,
                model_id: formData.model_id,
                variant_id: formData.variant_id,
                color_id: formData.color_id,
                fuel_type_id: formData.fuel_type_id,
                remark: formData.remark,
                is_test_drive: formData.is_test_drive ? 1 : 0,
                test_drive_assistance_name: null,
                test_drive_Date: formData.test_drive_Date,
                single_image: null,
                family_image: null,
              },
              {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${token}`,
                },
              }

            );

          }

          if( response.status === 200 ){
            toggleDrawer()
          }

          console.log(response, "RESPONSEData");
        } catch (error) {
          console.log(error, "Error");
        }
      };
      

      // const handleDrawerFormVehicle = async (formData) => {
      //   console.log("clicked")
      //   const errors = {};
      //   let isValid = true;
      //   VehicleDrawerInputs.forEach((field) => {
      //     if (field.validation && field.validation.required) {
      //       if (!formData[field.name]) {
      //         errors[field.name] = "This field is required";
      //         isValid = false;
      //       }
      //     } else if (
      //       field.required &&
      //       field.validation &&
      //       field.validation.pattern &&
      //       !field.validation.pattern.test(formData[field.name])
      //     ) {
      //       errors[field.name] = field.validation.message;
      //       isValid = false;
      //     }
      //   });
    
      //   if (!isValid) {
      //     setValidationErrors(errors);
      //     return;
      //   }

      //   try{

      //     const resposne = await axiosInstance.post(
      //       "/salesvisit/createcustomervisitvehicle",
      //       {
      //         business_partner_id: 1,
      //         visit_id: visit_id,
      //         product_id: formData.product_id,
      //         subproduct_id: formData.subproduct_id,
      //         make_id: formData.make_id,
      //         model_id: formData.model_id,
      //         variant_id: formData.variant_id,
      //         color_id: formData.color_id,
      //         fuel_type_id: formData.fuel_type_id,
      //         remark:formData.remark,
      //         is_test_drive: formData.is_test_drive ? 1 : 0,
      //         test_drive_assistance_name:null,
      //         test_drive_Date:null,
      //         single_image:null,
      //         family_image:null,
      //       },
      //       {
      //         headers: {
      //           "Content-Type": "application/json",
      //           Authorization: `Bearer ${token}`,
      //         },
      //       }
      //     );

      //     console.log(resposne, "RESPOSNEData")
    
      //   }catch(error){
      //     console.log(error)
      //   }


      // }


      useEffect(() => {
        fetchFuelType();
      }, []);
    
      const fetchFuelType = async () => {
        try {
          const business_partner_id = 1;
          const response = await axiosInstance.post(
            "/fueltype/ddlfueltype",
            {
              business_partner_id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            }
          );
    
          const options = response.data.data.data.map((data) => ({
            label: data.NAME,
            value: data.ID,
          }));
    
          setFuelType(options);
          console.log(options, "OPTIONS");
        } catch (error) {
          console.error("Error fetching product options:", error);
        }
      };


      useEffect(() => {
        fetchColorOptions()
      },[])

      const fetchColorOptions = async () => {
        try {
    
          const business_partner_id = 1;
    
          const response = await axiosInstance.post('/color/ddlcolor', {
            business_partner_id
          }, {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            }
          });
    
          const options = response.data.data.data.map(color => ({
            label: color.NAME,
            value: color.ID,
          }));
    
          setColor(options);
        } catch (error) {
          console.error('Error fetching color options:', error);
        }
      };

      const VehicleDrawerInputs = [
        {
          name: "product_id",
          label: "Product",
          placeholder: "Select City",
          type: "dropdown",
          options: product,
          required: true,
          gridClass: "col-lg-8",
        },
        {
          name: "subproduct_id",
          label: "Subproduct Name",
          type: "dropdown",
          options: subproduct,
          gridClass: "col-lg-8",
          required: true,
        },
        {
          name: "make_id",
          label: "Make",
          placeholder: "Select City",
          type: "dropdown",
          options: make,
          required: true,
          gridClass: "col-lg-8",
        },
        {
          name: "model_id",
          label: "Model",
          placeholder: "Select ",
          type: "dropdown",
          options: model,
          required: true,
          gridClass: "col-lg-8",
        },
        {
          name: "variant_id",
          label: "Variant",
          type: "dropdown",
          options: variantDD,
          required: true,
          gridClass: "col-lg-8",
          validation: { required: true },
        },
        {
          name: "color_id",
          label: "Color",
          type: "dropdown",
          options: color,
          required: true,
          gridClass: "col-lg-8",
          validation: { required: true },
        },
        {
          name: "fuel_type_id",
          label: "Fuel Type",
          type: "dropdown",
          options: fuelType,
          required: true,
          gridClass: "col-lg-8",
          validation: { required: true },
        },
        {
          name: "remark",
          label: "Remark",
          type: "text",
          placeholder: "Enter Remark",
          required: true,
          gridClass: "col-lg-8",
          validation: { required: true },
        },

        {
          name: "is_test_drive",
          label: "Test Drive Required",
          type: "toggle",
          required: false,
          options: [{ label: "Extended Warranty", value: 1 }],
          gridClass: "col-lg-8",
        },
        {
            name: "test_drive_assistance_name",
            label: "Test Driver Name",
            type: "text",
            placeholder: "Enter Name",
            required: showParentDesignation ? true:false,
            isVisible: false,
            gridClass: "col-lg-8",
            validation: { required: showParentDesignation ? true:false },
          },
        {
          name: "test_drive_Date",
          label: "Date and Time",
          type: "datetime",
          required: showParentDesignation ? true:false,
          isVisible: false,
          gridClass: "col-lg-9",
          validation: { required: showParentDesignation ? true:false },
        },
        {
          name: "single_image",
          label: "Single Image Upload",
          type: "file",
          required: true,
          gridClass: "col-lg-4",
          required: showParentDesignation ? true:false,
          validation: { required: showParentDesignation ? true:false },
          isVisible: false,
        },
        {
          name: "family_image",
          label: "Family Image Upload",
          type: "file",
          required: true,
          gridClass: "col-lg-4",
          required: showParentDesignation ? true:false,
          validation: { required: showParentDesignation ? true:false },
          isVisible: false,
        },
      ];

      const DEPARTMENT_TABLE_HEADERS = [
        "Product",
        "SubProduct",
        "Variant",
        "Make",
        "Model",
        "Color",
        "Fuel Type",
        "Test Driver Name",
        "Test Drive Date",
        "Action",
      ];
    
      // Key mapping for CustomTable component
      const DEPARTMENT_KEY_MAPPING = {
        "Product":"product_name",
        "SubProduct":"subproduct_name",
        "Variant": "variant_name",
        "Item Name": "item_name",
        "Item Type": "itemtypename",
        "Make": "make_name",
        "Model": "model_name",
        "Color":"color_name",
        "Fuel Type":"fuel_type_name",
        "Test Driver Name":"test_drive_assistance_name",
        "Test Drive Date":"test_drive_Date",
        Action: [
          { type: "edit", icon: editIcon, label: "Edit" },
          { type: "delete", icon: deleteIcon, label: "Delete" },
        ],
      };

  
      useEffect(() => {
    fetchProductOptions();
  }, []);

  const fetchProductOptions = async () => {
    try {
      const response = await axiosInstance.post(
        "/product/list",
        {
          orderBy: "product_id desc",
          page: 0,
          pageSize: 100, // Adjust as needed
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const options = response.data.data.data.map((product) => ({
        label: product.product_name,
        value: product.product_id,
      }));

      setProduct(options);
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    const productId = formData.product_id;
    if(productId){
      fetchSubproduct(productId);
      setSubproduct([])
    }
  }, [formData.product_id]);

  const fetchSubproduct = async (productId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/subproduct/ddlsubproduct",
        {
          business_partner_id,
          product_id: productId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const options = response.data.data.data.map((data) => ({
        label: data.NAME,
        value: data.ID,
      }));

      setSubproduct(options);
      console.log(options, "OPTIONS");
    } catch (error) {
      console.error("Error fetching product options:", error);
    }
  };

  useEffect(() => {
    const subProductId = formData.subproduct_id;
    const productId = formData.product_id;
    if (subProductId && productId){
      fetchMakeDD(subProductId, productId)
      setMake([])
    }
  },[formData.subproduct_id, formData.product_id])

  const fetchMakeDD = async (productId, subProductId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/make/ddlmake",
        {
          business_partner_id,
          product_id: productId,
          subproduct: subProductId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const makedata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setMake(makedata);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    const subProductId = formData.subproduct_id;
    const makeId = formData.make_id;
    const productId = formData.product_id;
    if (productId && makeId && subProductId) {
      fetchModelDD(makeId, productId, subProductId);
      setModel([]);
    }
  }, [formData.make_id, formData.product_id,formData.subproduct_id ]);

  const fetchModelDD = async (makeId, productId, subProductId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/model/ddlmodel",
        {
          business_partner_id,
          product_id: productId,
          make: makeId,
          subproduct_id: subProductId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const modeldata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setModel(modeldata);
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {

    const subProductId = formData.subproduct_id;
    const makeId = formData.make_id;
    const productId = formData.product_id;
    const modelId = formData.model_id

    if (productId && makeId && subProductId && modelId) {
      fetchVariantDD(makeId, productId, subProductId, modelId);
      setVariantDD([]);
    }

    // fetchVariantDD()
  },[formData.make_id, formData.product_id,formData.subproduct_id,formData.model_id])

  const fetchVariantDD = async (makeId, productId, subProductId, modelId) => {
    try {
      const business_partner_id = 1;
      const response = await axiosInstance.post(
        "/variant/ddlvariant",
        {
          business_partner_id,
          product_id: productId,
          make: makeId,
          subproduct_id: subProductId,
          model_id:modelId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const fetchedData = response.data.data.data;
      const variantdata = fetchedData.map((dropdown) => ({
        value: dropdown.ID,
        label: dropdown.NAME,
      }));
      setVariantDD(variantdata);
    } catch (error) {
      console.log(error, "error");
    }
  };



  useEffect(() => {
    VehicleDetailsData()
  },[])

  useEffect(() => {
    console.log(formData, "FORMDATAStatus")
    if(formData?.is_test_drive === true){
      setShowParentDesignation(true)
    }
  },[formData?.is_test_drive])

  
  const VehicleDetailsData = async () => {
    try{
      const response = await axiosInstance.post(`/salesvisit/customervisitvehiclelist`,{
    business_partner_id:1,
    visit_id: visit_id

      },{
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
    })

    // const formatedData = response.data.data.data
    // console.log(formatedData, "RESPONSE")


    const formatedData = response.data.data.data.map((item, index) => ({
      ...item,
      // "Sr No.": index + 1  ,
      test_drive_Date: new Date(item.test_drive_Date).toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      }) 
    }));

    setVehicleDetailsData(formatedData)
  
  }catch(error){
      console.log(error)
    }
  }

  const handleDelete = async (rowData) => {
    console.log("rowDatadelete>>>>", rowData);

    try {
      const response = await axiosInstance.post(
        `/salesvisit/deletecustomervehicle`, {
          business_partner_id:1,
          vehicle_id:rowData?.vehicle_id
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if(response.status === 200){
        VehicleDetailsData()
      }

    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  return (
    <div>
        <div className='vehcileDetailsTopbar'>
        <h5 style={{paddingLeft:"55px"}} className='mt-2 mb-2 header-details'>Vehicle Details</h5>
        <div className='addVehicle'>
        <div>
              <AddVehicleDetails VehicleDetailsData={VehicleDetailsData} setIsOpen={setIsOpen} isOpen={isOpen} setIsEdit={setIsEdit} toggleDrawer={toggleDrawer}  isEdit={isEdit} vehicleId={vehicleId}  visit_id={visit_id} />
          
          </div>
        </div>
        </div>

        <CustomLogisticsTable
          data={vehicleDetails}
          headers={DEPARTMENT_TABLE_HEADERS}
          keyMapping={DEPARTMENT_KEY_MAPPING}
          itemsPerPage={10}
          totalRecords={totalRecords} 
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
          onDelete={handleDelete}
          onEdit={handleEdit}
        //   onAddSerial={handleAddSerial}
        isADDcomplainTable={true}
        />


    </div>
  )
}

// http://127.0.0.1:8599/public/upload/

export default VehicleDetails